"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Modal = {
    defaultProps: {
        size: '2xl',
    },
};
exports.default = Modal;
